import styled, {css} from 'styled-components'

export const boldStyle = css`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`

export const italicStyle = css`
  font-style: italic;
`

export const Bold = styled.strong`
  ${boldStyle}
`

export const Italic = styled.span`
  ${italicStyle}
`

export const Paragraph = styled.p``

export const Underline = styled.span`
  text-decoration: underline;
`
